import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    headers: { "Content-Type": "application/json" },
});

// Also send Authorization header if we stash token in localStorage (belt + suspenders)
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("itotal4u_token");
    if (token && !config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export function formatApiError(err, fallback = "Ocurrió un error inesperado") {
    const detail = err?.response?.data?.detail;
    if (detail == null) return err?.message || fallback;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" · ");
    }
    if (detail && typeof detail.msg === "string") return detail.msg;
    return fallback;
}
